import { FC, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link, useLocation } from 'react-router-dom';
import { getConfig } from '../../config/config';
import {
  Header,
  Logo,
  StyledMenu,
  StyledMenuItem,
  StyledMenuItemGroup,
  StyledSider,
} from './style';

interface Props {
  width?: number;
}

const Sidebar: FC<Props> = ({ width }) => {
  const location = useLocation();
  const [current, setCurrent] = useState<string>('');

  useEffect(() => {
    const { pathname } = location;
    const currentPath = pathname.split('/');

    setCurrent(currentPath[1]);
  }, [location]);

  const handleClick = (e: any) => setCurrent(e.key);

  return (
    <StyledSider width={width} data-testid="sidebar">
      <Header>
        <Logo
          src={`${getConfig().userManagementEndpoint}/coherent_logo.png`}
          alt="coherent-logo"
        />
      </Header>

      <StyledMenu
        defaultSelectedKeys={['users']}
        selectedKeys={[current]}
        style={{ border: 'none' }}
        onClick={handleClick}
      >
        {getConfig().showUserManagement?.toString()?.toLowerCase() ===
          'true' && (
          <StyledMenuItemGroup
            key="admin"
            title="Administration"
            data-testid="sidebar-usersmanagement-nav"
          >
            <StyledMenuItem key="users">
              <Link to="/users" data-testid="sidebar-users-link">
                Users
              </Link>
            </StyledMenuItem>
            <StyledMenuItem key="groups">
              <Link to="/groups" data-testid="sidebar-groups-link">
                <FormattedMessage id="ApiKeys.form.label.userGroups" />
              </Link>
            </StyledMenuItem>
          </StyledMenuItemGroup>
        )}

        {getConfig().showApikeyManagement?.toString()?.toLowerCase() ===
          'true' && (
          <StyledMenuItemGroup
            key="dev-tools"
            title="Developers Tools"
            data-testid="sidebar-apikeysmanagement-nav"
          >
            <StyledMenuItem key="apikeys">
              <Link to="/apikeys" data-testid="sidebar-apikeys-link">
                <FormattedMessage id="ApiKeys.title" />
              </Link>
            </StyledMenuItem>
          </StyledMenuItemGroup>
        )}
      </StyledMenu>
    </StyledSider>
  );
};

export default Sidebar;
